export default __webpack_public_path__ + "static/media/Plissee 22 vertikal ausmessen.5851a2f4.jpg";